<div [ngClass]="{loading: isLoading}" *ngIf="!config.pillar_models">
    <true-breadcrumbs [subset]="this.config.subset" [pillar]="selectedPillar" [indicator]="selectedIndicator" [assessmentName]="assessmentName + ' (' + assessmentObject + ')'"></true-breadcrumbs>    
    <div *ngIf="!selectedPillar">
        <true-review-ratings *ngIf="assessmentId" [assessmentId]="assessmentId" [pillars]="pillars" (selectPillar)="selectPillar($event)" (selectIndicator)="selectIndicator($event)"></true-review-ratings>
    </div>
    <div *ngIf="selectedPillar">
        <true-pillar-selector [pillars]="pillars" [selectedPillar]="selectedPillar" (select)="selectPillar($event)"></true-pillar-selector>
        <true-pillar [assessmentId]="assessmentId" [pillar]="selectedPillar" [indicator]="selectedIndicator" (update)="updateSelectedPillar($event)" (complete)="next($event)"></true-pillar>
    </div>
</div>

<div [ngClass]="{loading: isLoading}" *ngIf="config.pillar_models">
    <true-breadcrumbs [subset]="this.config.subset" [pillar]="selectedPillar" [indicator]="selectedIndicator" [assessmentName]="assessmentName"></true-breadcrumbs>
    <div *ngIf="!selectedPillar">
        <true-review-ratings *ngIf="assessmentId" [assessmentId]="assessmentId" [pillars]="pillars" (selectPillar)="selectPillar($event)" (selectIndicator)="selectIndicator($event)"></true-review-ratings>
    </div>
    
    <div class="adjustWidth" *ngIf="selectedPillar">
        <true-pillar-selector [pillars]="pillars" [selectedPillar]="selectedPillar" (select)="selectPillar($event)"></true-pillar-selector>
        <true-pillar [assessmentId]="assessmentId" [pillar]="selectedPillar" [(indicator)]="selectedIndicator" (update)="updateSelectedPillar($event)" (complete)="next($event)"></true-pillar>
    </div>
</div>